import { userApi } from './userApi';
import { postApi } from './postApi';

export const searchApi = {
  search: async (query, limit = 20, offset = 0) => {
    // Search users and posts in parallel
    const [usersResponse, postsResponse] = await Promise.all([
      userApi.search(query, limit, offset),
      postApi.search(query, limit, offset),
    ]);

    return {
      users: usersResponse.success ? usersResponse.data : [],
      posts: postsResponse.success ? postsResponse.data : [],
    };
  },

  searchUsers: async (query, limit = 20, offset = 0) => {
    return await userApi.search(query, limit, offset);
  },

  searchPosts: async (query, limit = 20, offset = 0) => {
    return await postApi.search(query, limit, offset);
  },
};
